import React from 'react';

import { RawPortableText } from '../../types/types';
import ItemGridModule, { ItemGrid } from './modules/ItemGridModule';

interface CharacteristicsSectionProps {
  title: string;
  characteristics: Array<{
    title: string;
    additionalExplanation?: string;
    description: RawPortableText;
  }>;
}

const CharacteristicsSection = ({
  title,
  characteristics,
}: CharacteristicsSectionProps): React.ReactElement => {
  const characteristicsAsItems = characteristics.map(characteristic => ({
    title: characteristic.title,
    additionalExplanation: characteristic.additionalExplanation,
    text: characteristic.description,
    icon: undefined,
  })) as Array<ItemGrid>;

  return <ItemGridModule items={characteristicsAsItems} title={title} />;
};

export default CharacteristicsSection;
